<div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
</div>
<form name="form" #form="ngForm">
    <div class="modal-body">
        <div class="row">
            <div class="col-md-8">
                <div class="form-group">
                    <label for="equipment">Equipment</label>
                    <wj-combo-box
                        id="equipment"
                        name="equipment"
                        [(ngModel)]="target.equipment"
                        [itemsSource]="equipmentOptions"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                        required
                    ></wj-combo-box>
                </div>
            </div>
            <div class="col-md-4">
                <div class="form-group">
                    <label for="quantity">Quantity</label>
                    <input id="quantity" type="number" class="form-control" [(ngModel)]="target.quantity" name="quantity" />
                </div>
            </div>
        </div>
        <div class="form-group">
            <label for="filterType">Filter type</label>
            <input id="filterType" type="text" class="form-control" [(ngModel)]="target.filterType" name="filterType" required />
        </div>
        <div class="row">
            <div class="col-md-4">
                <div class="form-group">
                    <label for="oemPartNumber">OEM filter #</label>
                    <input id="oemPartNumber" type="text" class="form-control" [(ngModel)]="target.oemPartNumber" name="oemPartNumber" />
                </div>
            </div>
            <div class="col-md-4">
                <div class="form-group">
                    <label for="baldwinPartNumber">Baldwin filter #</label>
                    <input id="baldwinPartNumber" type="text" class="form-control" [(ngModel)]="target.baldwinPartNumber" name="baldwinPartNumber" />
                </div>
            </div>
            <div class="col-md-4">
                <div class="form-group">
                    <label for="fleetguardPartNumber">Fleetguard filter #</label>
                    <input id="fleetguardPartNumber" type="text" class="form-control" [(ngModel)]="target.fleetguardPartNumber" name="fleetguardPartNumber" />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-4">
                <div class="form-group">
                    <label for="napaPartNumber">NAPA #</label>
                    <input id="napaPartNumber" type="text" class="form-control" [(ngModel)]="target.napaPartNumber" name="napaPartNumber" />
                </div>
            </div>
            <div class="col-md-4">
                <div class="form-group">
                    <label for="advanceAutoPartNumber">Advance Auto</label>
                    <input id="advanceAutoPartNumber" type="text" class="form-control" [(ngModel)]="target.advanceAutoPartNumber" name="advanceAutoPartNumber" />
                </div>
            </div>
            <div class="col-md-4">
                <div class="form-group">
                    <label for="wheelerPartNumber">Wheeler filter #</label>
                    <input id="wheelerPartNumber" type="text" class="form-control" [(ngModel)]="target.wheelerPartNumber" name="wheelerPartNumber" />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-4">
                <div class="form-group">
                    <label for="donaldsonPartNumber">Donaldson</label>
                    <input id="donaldsonPartNumber" type="text" class="form-control" [(ngModel)]="target.donaldsonPartNumber" name="donaldsonPartNumber" />
                </div>
            </div>
            <div class="col-md-4">
                <div class="form-group">
                    <label for="wixPartNumber">Wix</label>
                    <input id="wixPartNumber" type="text" class="form-control" [(ngModel)]="target.wixPartNumber" name="wixPartNumber" />
                </div>
            </div>
            <div class="col-md-4">
                <div class="form-group">
                    <label for="kenworthPartNumber">Kenworth</label>
                    <input id="kenworthPartNumber" type="text" class="form-control" [(ngModel)]="target.kenworthPartNumber" name="kenworthPartNumber" />
                </div>
            </div>
        </div>
        <div class="form-group">
            <label for="notes">Notes</label>
            <textarea id="notes" class="form-control" rows="2" [(ngModel)]="target.notes" name="notes"></textarea>
        </div>
    </div>
    <div class="modal-footer">
        <button id="btnSave" type="submit" class="btn btn-primary" (click)="save()" [disabled]="form.invalid || isSaving">
            @if (isSaving) {
                <span><fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon>&nbsp;Saving</span>
            } @else {
                <span>Save</span>
            }
        </button>
        <button id="btnCancel" type="button" class="btn btn-secondary" (click)="cancel()" [disabled]="isSaving">Cancel</button>
    </div>
</form>
